import Axios from "axios";
import {
    SET_APPROVAL_MATRIX_LIST,
    UNSET_APPROVAL_MATRIX_LIST
  } from "@/store/mutation-types";
import { saveUpdateApprovalMatrix, getApprovalMatrixList, getApprovalMatrixById  } from "@/store/api";
// initial state
const state = {
  getApprovalMatrixList: [],
};

const getters = {
  getApprovalMatrixList(state) {
    return state.getApprovalMatrixList;
  },
};
const mutations = {
  [SET_APPROVAL_MATRIX_LIST](state, data) {
    state.getApprovalMatrixList = data;
  },
  [UNSET_APPROVAL_MATRIX_LIST](state) {
    state.getApprovalMatrixList = [];
  },

};

const actions = {

  saveUpdateApprovalMatrix({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateApprovalMatrix, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getApprovalMatrixList({ commit }, params) {
    return new Promise((resolve, reject) => {
      Axios.get(getApprovalMatrixList, { params })
        .then(function (response) {
          commit('SET_APPROVAL_MATRIX_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_APPROVAL_MATRIX_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getApprovalMatrixById({ commit }, id) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.get(getApprovalMatrixList)
        .then((response) => {
          const list = response?.data?.data || [];
          const found = list.find((item) => String(item.id) == String(id));
          if (found) {
            resolve(found);
          } else {
            reject(new Error("Approval matrix not found"));
          }
        })
        .catch((error) => {
          reject(error);
        })
        .then(() => {
          commit("UNSET_LOADING");
        });
    });
  },

};

export default {
  state,
  getters,
  actions,
  mutations,
};
